<template>
  <a-verify-account-widget
    @verified="goHome"
    @cancel="goLogin"
  ></a-verify-account-widget>
</template>

<script>
export default {
  name: 'ForgotPasswordPage',
  methods: {
    goHome () {
      this.$router.push('/')
    },
    goLogin() {
      this.$router.push('/login')
    }
  }
}
</script>